import { SVGProps } from "react";

export default function BscBalanceIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={props.width ? props.width : "12"}
      height={props.height ? props.height : "12"}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={props.className}
    >
      <path
        d="M5.82498 1.17281L3.17998 3.81781C3.07998 3.91781 3.07998 4.07281 3.17998 4.17281L3.82498 4.81781C3.92498 4.91781 4.07998 4.91781 4.17998 4.81781L5.82498 3.17281C5.92498 3.07281 6.07998 3.07281 6.17998 3.17281L7.82498 4.81781C7.92498 4.91781 8.07998 4.91781 8.17998 4.81781L8.82498 4.17281C8.92498 4.07281 8.92498 3.91781 8.82498 3.81781L6.17998 1.17281C6.07998 1.07781 5.91998 1.07781 5.82498 1.17281Z"
        fill={props.fill ? props.fill : "#7B7B7B"}
      />
      <path
        d="M5.82498 10.8216L3.17998 8.17656C3.07998 8.07656 3.07998 7.92156 3.17998 7.82156L3.82498 7.17656C3.92498 7.07656 4.07998 7.07656 4.17998 7.17656L5.82498 8.82156C5.92498 8.92156 6.07998 8.92156 6.17998 8.82156L7.82498 7.17656C7.92498 7.07656 8.07998 7.07656 8.17998 7.17656L8.82498 7.82156C8.92498 7.92156 8.92498 8.07656 8.82498 8.17656L6.17998 10.8216C6.07998 10.9166 5.91998 10.9166 5.82498 10.8216Z"
        fill={props.fill ? props.fill : "#7B7B7B"}
      />
      <path
        d="M10.0501 5.04781L10.8201 5.81781C10.9201 5.91781 10.9201 6.07281 10.8201 6.17281L10.0501 6.94281C9.9501 7.04281 9.79509 7.04281 9.69509 6.94281L8.9251 6.17281C8.8251 6.07281 8.8251 5.91781 8.9251 5.81781L9.69509 5.04781C9.79509 4.95281 9.9551 4.95281 10.0501 5.04781Z"
        fill={props.fill ? props.fill : "#7B7B7B"}
      />
      <path
        d="M2.3001 5.04781L3.07009 5.81781C3.17009 5.91781 3.17009 6.07281 3.07009 6.17281L2.3001 6.94281C2.2001 7.04281 2.04509 7.04281 1.94509 6.94281L1.1751 6.17281C1.0751 6.07281 1.0751 5.91781 1.1751 5.81781L1.94509 5.04781C2.04509 4.95281 2.2051 4.95281 2.3001 5.04781Z"
        fill={props.fill ? props.fill : "#7B7B7B"}
      />
      <path
        d="M6.17511 4.94219L7.06011 5.82719C7.16011 5.92719 7.16011 6.08219 7.06011 6.18219L6.17511 7.06719C6.07511 7.16719 5.92011 7.16719 5.82011 7.06719L4.93511 6.18219C4.83511 6.08219 4.83511 5.92719 4.93511 5.82719L5.82011 4.94219C5.92011 4.84219 6.08011 4.84219 6.17511 4.94219Z"
        fill={props.fill ? props.fill : "#7B7B7B"}
      />
    </svg>
  );
}
